<!-- Footer -->
<footer class="footer-wrapper d-flex flex-column bd-highlight mb-3">
  <div class="mt-auto p-2 bd-highlight d-flex flex-wrap bd-highlight copy">
    <span class="copyright small mb-4 mb-lg-0">&copy; Комплекс Інжиніринг Системз 2023. Всі права захищені</span>
  </div>
</footer>
